const context = 'venueSettings'

export const FETCH_VENUE_SETTINGS_REQUESTED = `${context}/FETCH_VENUE_SETTINGS_REQUESTED`
export const FETCH_VENUE_SETTINGS_SUCCEEDED = `${context}/FETCH_VENUE_SETTINGS_SUCCEEDED`
export const FETCH_VENUE_SETTINGS_FAILED = `${context}/FETCH_VENUE_SETTINGS_FAILED`

export const CREATE_VENUE_SETTINGS_REQUESTED = `${context}/CREATE_VENUE_SETTINGS_REQUESTED`
export const CREATE_VENUE_SETTINGS_SUCCEEDED = `${context}/CREATE_VENUE_SETTINGS_SUCCEEDED`
export const CREATE_VENUE_SETTINGS_FAILED = `${context}/CREATE_VENUE_SETTINGS_FAILED`

export const FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_REQUESTED = `${context}/FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_REQUESTED`
export const FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_SUCCEEDED = `${context}/FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_SUCCEEDED`
export const FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_FAILED = `${context}/FETCH_SETTINGS_WITH_DEFAULT_SETTINGS_FAILED`

export const CREATE_VENUE_SETTINGS_NEW_REQUESTED = `${context}/CREATE_VENUE_SETTINGS_NEW_REQUESTED`
export const CREATE_VENUE_SETTINGS_NEW_SUCCEEDED = `${context}/CREATE_VENUE_SETTINGS_NEW_SUCCEEDED`
export const CREATE_VENUE_SETTINGS_NEW_FAILED = `${context}/CREATE_VENUE_SETTINGS_NEW_FAILED`

export const FETCH_SETTINGS_FOR_STANDS_REQUESTED = `${context}/FETCH_SETTINGS_FOR_STANDS_REQUESTED`
export const FETCH_SETTINGS_FOR_STANDS_SUCCEEDED = `${context}/FETCH_SETTINGS_FOR_STANDS_SUCCEEDED`
export const FETCH_SETTINGS_FOR_STANDS_FAILED = `${context}/FETCH_SETTINGS_FOR_STANDS_FAILED`
